/** Returns true if `latest` is a newer semver than `current`. Prerelease/build metadata is stripped. */
export function isNewerVersion(latest: string, current: string): boolean {
  const strip = (v: string) => v.replace(/[-+].*$/, '');
  const l = strip(latest).split('.').map(Number);
  const c = strip(current).split('.').map(Number);
  for (let i = 0; i < Math.max(l.length, c.length); i++) {
    const lv = l[i] ?? 0;
    const cv = c[i] ?? 0;
    if (Number.isNaN(lv) || Number.isNaN(cv)) return false;
    if (lv > cv) return true;
    if (lv < cv) return false;
  }
  return false;
}
